import { render, staticRenderFns } from "./LiveShoppingEventStartCountdown.vue?vue&type=template&id=1a837aea&scoped=true"
import script from "./LiveShoppingEventStartCountdown.vue?vue&type=script&lang=js"
export * from "./LiveShoppingEventStartCountdown.vue?vue&type=script&lang=js"
import style0 from "./LiveShoppingEventStartCountdown.vue?vue&type=style&index=0&id=1a837aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a837aea",
  null
  
)

export default component.exports